export default __webpack_public_path__ + "a05c2ad9d61ad4c0aa8a347a92b045b6.svg";